import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import Hubble from '@/views/hubble'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				authorizd: false
			}
		}
		, {
			path: '/hubble/:id',
			name: 'hubble',
			component: Hubble
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js